// extracted by mini-css-extract-plugin
module.exports = {"button":"styled-button_button___64Z0","active":"styled-button_active__6_gtX"};